import { loadStripe } from '@stripe/stripe-js/pure';
let stripe;
function _isTrue(val) {
    return val === 'true';
}
function delayNextRetry(retryCount) {
    const delay = 2 ** retryCount * 500;
    return new Promise(resolve => {
        setTimeout(resolve, delay + delay * 0.2 * Math.random());
    });
}
export async function getStripeInstance(locale) {
    if (!stripe) {
        if (!locale && _isTrue('false')) {
            locale = window.$nuxt.$i18n.locale;
        }
        let retries = 0;
        do {
            try {
                stripe = await loadStripe('pk_live_K7ugqHbeUlJHnpZi9pDs8AQt', { locale });
            }
            catch (e) {
                stripe = null;
                retries++;
                await delayNextRetry(retries);
            }
        } while (!stripe && retries < 3);
        if (!stripe) {
            throw new Error(`nuxt-stripejs: Failed to load Stripe.js after ${retries} retries`);
        }
    }
    return stripe;
}
const stripePlugin = (ctx, inject) => {
    inject('stripe', getStripeInstance);
};
export default stripePlugin;
//# sourceMappingURL=plugin.js.map